/** randomUUID needs HTTPS; getRandomValues also works on the LAN HTTP preview. */
export function operationId(): string {
  if (globalThis.crypto.randomUUID) return globalThis.crypto.randomUUID();
  return Array.from(
    globalThis.crypto.getRandomValues(new Uint8Array(16)),
    (n) => n.toString(16).padStart(2, "0"),
  ).join("");
}
